import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 1303px;
`;

export const DropzoneWrapper = styled.div`
  padding: 50px 50px  100px 0;
  max-width: 612px;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
`;

export const Dropzone = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 560px;
  height: 364px;
  background: #F8F8F8;
  border: 1px dashed #0EA3F5;
  border-radius: 10px;
  cursor: pointer;
`;

export const Title = styled.div`
  font-size: 20px;
  color: #949494;
  span {
    color: #0076C0;
    font-weight: bold;
    margin-left: 15px;
  }
`;

export const InfoText = styled.div`
  color: #949494;
  font-size: 12px;
  margin-top: 10px;
`;

export const Example = styled.div`
  color: #666666;
  font-size: 12px;
  margin-top: 60px;
  text-align: center;
  a {
    color: #0076BF;
    font-size: 14px;
  }
`;

export const FilesWrapper = styled.div`
  padding: 50px;
`;

export const Files = styled.div`
  width: 591px;
  height: 523px;
  background: #FFFFFF;
  border: 1px solid #CED4DA;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding: 40px;
`;

export const FilesTitle = styled.div`
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 25px;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-right: 50px;
  margin-bottom: 50px;
  & > * {
    margin-left: 10px;
  }
`;